import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const loggedIn = useSelector(state => state.authentication.loggedIn);
  const loggingOut = useSelector(state => state.authentication.loggingOut);
  const user = useSelector(state => state.authentication.user);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        loggedIn && !loggingOut && user ? (
          <Component />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: location } }} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  location: PropTypes.object,
};

export default PrivateRoute;
